// modal-template-create-student-group.js
import axios from 'axios';

const classPrefix = 'modal-template-create-student-group';
const dataPrefix = 'data-modal-template-create-student-group';
import { input } from '../../input/input';
export function modalTemplateCreateStudentGroup($container) {
    const $template = document.querySelector(`[${dataPrefix}-template]`)

    init();
    function init(){
        const $modalClone = document.importNode($template.content, true)

        const $form = $modalClone.querySelector(`[${dataPrefix}-form]`);
        const $confirm = $modalClone.querySelector(`[${dataPrefix}-confirm]`);

        renderFields($form)
        ensureStatusField($form);
        $confirm.addEventListener('click', () => {
            submitCreate($form, $confirm);
        });

        $container.appendChild($modalClone)
    }
    function renderFields($form) {
        // очищаем от предыдущих
        $form.innerHTML = '';

        input($form, {
            type: 'text',
            label: 'Название группы',
            name: 'name',
            autocomplete: 'name',
            required: true,
        });

    }

    function ensureStatusField($form) {
        // общий статус/ошибка
        let $status = $form.querySelector(`.${classPrefix}__status`);
        if (!$status) {
            $status = document.createElement('div');
            $status.className = `${classPrefix}__status`;
            $form.appendChild($status);
        }
    }

    function setStatusMessage($form, message, isError = true) {
        const $status = $form.querySelector(`.${classPrefix}__status`);
        if (!$status) return;
        $status.textContent = message || '';
        $status.style.display = message ? 'block' : 'none';
        $status.classList.toggle('is-error', isError);
    }

    function clearErrors($form) {
        // удаляем старые текстовые сообщения ошибок под input'ами
        $form.querySelectorAll(`.${classPrefix}__field-error`).forEach(e => e.remove());
        setStatusMessage($form, '');
        // сброс состояния инпутов
        $form.querySelectorAll('input, textarea').forEach(el => {
            el.classList.remove('is-invalid');
        });
    }

    // главная функция отправки
    async function submitCreate($form, $confirmBtn) {
        clearErrors($form);
        setStatusMessage($form, '');

        // собираем поля по имени
        const payload = {};
        $form.querySelectorAll('input[name], textarea[name]').forEach(($el) => {
            const name = $el.getAttribute('name');
            // для чекбоксов/радио можно добавить ветку, но здесь простые поля
            payload[name] = $el.value;
        });

        // UI: блокируем кнопку
        const oldBtnText = $confirmBtn.textContent;
        $confirmBtn.setAttribute('disabled', 'true');
        $confirmBtn.classList.add('is-loading');
        $confirmBtn.textContent = 'Создаем...';

        // Настройки axios для laravel
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.common['Accept'] = 'application/json';

        // CSRF: попробуем прочитать meta-tag, если он есть
        const metaToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (metaToken) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = metaToken;
        }

        try {
            const response = await axios.post('api/create-student-group', payload);
            document.dispatchEvent(new CustomEvent('account-groups:created'));
            document.dispatchEvent(new CustomEvent('modal-template:close'));
        } catch (error) {
            setStatusMessage($form, error.response.data.message, true);
            console.error(error);
        } finally {
            // разблокируем кнопку
            $confirmBtn.removeAttribute('disabled');
            $confirmBtn.classList.remove('is-loading');
            $confirmBtn.textContent = oldBtnText;
        }
    }
}
